import React from "react";
import NewMessage from "./NewMessage";
import DummyForm from "./DummyForm";

const DraftsMessages = () => {
  return (
    <div>
     <DummyForm></DummyForm>
    </div>
  );
};

export default DraftsMessages;
